import { createAction } from "@reduxjs/toolkit";

export const addUsedHook = createAction<string>("site/addUsedHook");
